import React from 'react';
import './App.css';
import gsap from "gsap/all";
import { TweenMax, CSSRulePlugin } from "gsap/all";


gsap.registerPlugin(CSSRulePlugin);


let rule;
export default class NutritionalInfo extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.NutritionalInfoRef = React.createRef();

  }

  componentDidMount () {
    rule = CSSRulePlugin.getRule(".single_menu .single_menu_body:after"); //get the rule

    //TweenMax.to('.single_menu_body:after',.5, {alpha: 1});
    TweenMax.to(rule, {duration: .5, cssRule: {opacity: 1}});

    TweenMax.set(this.NutritionalInfoRef.current,{alpha: 0, scale:.9})
    TweenMax.to(this.NutritionalInfoRef.current, .5, {delay: .8, alpha: 1, scale:1});
    window.scrollTo(0,0);
  }

  componentWillUnmount() {
    this.NutritionalInfoRef = null;
  }

  onBack (e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    let self = this;


    TweenMax.to(rule, {duration: .5, cssRule: {opacity: 0}});
    TweenMax.to(this.NutritionalInfoRef.current, .5, {alpha: 0, scale:.9, onComplete:()=>{
      self.props.update(false, self.NutritionalInfoRef);
      if (this.props.lastHash === window.location.hash.substring(0, window.location.hash.length)) {
        window.location.href = window.location.hash.split("/")[0]
      }
      else {
        window.location.href = this.props.lastHash;
      }
    }});

  }

  render() {
    const list = this.props.data.nutritionalInfo.map((obj)=>{
      let subList = "";
      if (obj.subitems) {
        subList = obj.subitems.map((subItem)=>{
          return (
            <li key={subItem.per_serving} className="row_wrap">
              <span className="left">{window.decodeHtml(subItem.title)}</span>
              <span className="right">{window.decodeHtml(subItem.per_serving)}</span>
            </li>
          )
        });
      }
      return (

          <li key={obj.id}>
            <div className="row_wrap">
              <span className="left">{window.decodeHtml(obj.title)}</span>
              <span className="right">{window.decodeHtml(obj.per_serving)}</span>
            </div>
            {subList ?
              <ul className="sub_row">
              {subList}
              </ul>: ""
            }
          </li>
        );
    });

    const allergyList = this.props.data.allergens? this.props.data.allergens.map((obj)=>{
      return (
          <div className="allergy">{window.decodeHtml(obj.allergy)}</div>
        );
    }): "";


    return (
      <section className="single_menu" >
      <div className="single_menu_body">
        <div className="container" ref={this.NutritionalInfoRef}>
          <span onClick={this.onBack.bind(this)} className="back_nav"><span className="icon">
          <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 0.999512L5 4.99951L9 0.999512" stroke="#fff" strokeWidth="0.996241" strokeLinecap="round" strokeLinejoin="bevel"></path>
          </svg>
          </span>Back to menu</span>
				  <div className="single_menu_wrapper">
			    	<div className="title_wrapper">
			    		<h1>{window.decodeHtml(this.props.data.title)}</h1>
			    		<p></p>
			    	</div>

			    	<ul className="nutrition_wrapper">
              <li className="table-heading">
			    			<div className="row_wrap">
				    			<span className="left">Nutritional Information</span>
				    			<span className="right">Per 100g</span>
				    		</div>
			    		</li>
              {list}
			    	</ul>

			    	<div className="allergens_information">
			    		<div className="allergens">
			    			<h4>Allergens</h4>
  			        {allergyList}
			    		</div>
			    		<div className="ingredients">
			    			<h4>Ingredients</h4>
			    			<p>{window.decodeHtml(this.props.data.ingredients)}</p>
			    		</div>
			    	</div>
			    </div>
        </div>

        </div>
        </section>
    );
  }
}
